import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RastreadorModeloService } from 'app/services/rastreador-modelo.service';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-rastreador-modelo-form',
  templateUrl: './rastreador-modelo-form.component.html',
  styleUrls: ['./rastreador-modelo-form.component.scss']
})
export class RastreadorModeloFormComponent implements OnInit {
  public id_rastreador_modelo: number;
  public nome: string;
  public descricao: string;
  public flg_status: number = 1;
  public isLoading = false;

  public href;
  public contentHeader: object;
  private routeSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private rastreadorModeloService: RastreadorModeloService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.href = this.route.url;

    if (this.href.value[1].path == "cadastro") {
      this.contentHeader = {
        headerTitle: "Cadastrar Modelo de Rastreador",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Modelo de Rastreador", isLink: false },
            { name: "Cadastrar", isLink: false }
          ]
        }
      };
    }

    if (this.href.value[1].path == "editar") {
      this.routeSub = this.route.params.subscribe(async (params) => {
        try {
          const modelo = await this.rastreadorModeloService.findOne(params["id"]);
          
          this.id_rastreador_modelo = params["id"];
          this.nome = modelo.nome;
          this.descricao = modelo.descricao;
          this.flg_status = modelo.flg_status || 1;
        } catch (error) {
          console.error('Erro ao carregar modelo:', error);
          Swal.fire({
            title: "Erro!",
            text: "Não foi possível carregar os dados do modelo.",
            icon: "error",
            confirmButtonText: "Ok"
          }).then(() => {
            this._router.navigate(['rastreador-modelo']);
          });
        }
      });

      this.contentHeader = {
        headerTitle: "Editar Modelo de Rastreador",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            { name: "Início", isLink: false },
            { name: "Modelo de Rastreador", isLink: false },
            { name: "Editar", isLink: false }
          ]
        }
      };
    }
  }

  public async submitForm(form: NgForm) {
    if (form.form.valid) {
      this.isLoading = true;
      try {
        const isCreate = this.href.value[1].path === "cadastro";
        const message = isCreate ? "cadastrado" : "atualizado";
        
        const response = isCreate
          ? await this.rastreadorModeloService.create(form.value)
          : await this.rastreadorModeloService.update(this.id_rastreador_modelo, form.value);

        await Swal.fire({
          title: "Sucesso!",
          text: `O modelo de rastreador foi ${message}.`,
          icon: "success",
          confirmButtonText: "Confirmar"
        });
        
        this._router.navigate(['rastreador-modelo']);
      } catch (error) {
        console.error('Erro na operação:', error);
        await Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao processar a requisição.",
          icon: "error",
          confirmButtonText: "Ok"
        });
      } finally {
        this.isLoading = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
